export class CotizacionConfig {
    id: number
    nombre: string
    img: string
    importes: string[]
    tags: string[]
    precioString: string
}